(() => {
  if (!document.body.classList.contains('template-search')) return;

  const url = new URL(window.location.href);
  const query = url.searchParams.get('q');
  if (!query) return;

  const cleanQuery = query
    .replace(/(?:^|\s)-available_for_sale:false(?:\s|$)/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  const configuredType = document.querySelector('.main-search__form [name="type"]')?.value || 'product';
  let needsRedirect = false;

  if (cleanQuery !== query) {
    if (cleanQuery) {
      url.searchParams.set('q', cleanQuery);
    } else {
      url.searchParams.delete('q');
    }
    needsRedirect = true;
  }

  if (url.searchParams.get('type') !== configuredType) {
    url.searchParams.set('type', configuredType);
    needsRedirect = true;
  }

  if (url.searchParams.get('options[unavailable_products]') !== 'hide') {
    url.searchParams.set('options[unavailable_products]', 'hide');
    needsRedirect = true;
  }

  if (url.searchParams.get('options[prefix]') !== 'last') {
    url.searchParams.set('options[prefix]', 'last');
    needsRedirect = true;
  }

  if (needsRedirect) {
    url.searchParams.delete('page');
    window.location.replace(url);
  }
})();
